import React, { useEffect, useRef, useState, useContext } from 'react';
import io from 'socket.io-client';
import Peer from 'simple-peer';
import * as Chance from 'chance';
import Video from './Video';
import {StreamContext} from '../Store'
import '../styles/video.css';
import { useAuth0 } from '@auth0/auth0-react';

const chance = new Chance();

const Room = (props) => {
  const { user, isAuthenticated, isLoading } = useAuth0();
  const [userDetails] = useState({
    id: chance.guid(),
    name: user.nickname,
  });
  const [, setPeers] = useState([]);
  const socketRef = useRef();
  const refVideo = useRef();
  const peersRef = useRef([]);
  const [stream, setStream]= useContext(StreamContext)
  const [isConnected, setIsConnected] = useState(true)

  // create an optimised callback via useCallback
  //const [refTest] = useHookWithRefCallback('hi')
  const roomId = props.match.params.roomId;
  useEffect(() => {
    navigator.mediaDevices
      .getUserMedia({ video: true, audio: true })
      .then((stream) => {
        refVideo.current.srcObject = stream;
        setStream(stream)
        socketRef.current = io.connect('https://socket-server.andrewpaige1.repl.co');

        // sending the user details and roomid to join in the room
        socketRef.current.emit('join-room', roomId, userDetails);

        socketRef.current.on('users-present-in-room', (users) => {
          const peers = [];

          // To all users who are already in the room initiating a peer connection
          users.forEach((user) => {
            const peer = createPeer(
              user.socketId,
              socketRef.current.id,
              stream
            );
           // setTemp([...peerTemp, {peerId: user.socketId, peer, name: user.name}])
            peersRef.current.push({
              peerId: user.socketId,
              peer,
              name: user.name,
            });

            peers.push({
              peerId: user.socketId,
              name: user.name,
              peerObj: peer,
            });
          });

          setPeers(peers);
        });

        // once the users initiate signal we will call add peer
        // to acknowledge the signal and send the stream
        socketRef.current.on('user-joined', (payload) => {
          const peer = addPeer(payload.signal, payload.callerId, stream);
          /*setTemp(...peerTemp, {            peerId: payload.callerId,
            peer,
            name: payload.name,})*/
          peersRef.current.push({
            peerId: payload.callerId,
            peer,
            name: payload.name,
          });
         // console.log(peersRef.current)

          setPeers((users) => [
            ...users,
            { peerId: payload.callerId, name: payload.name, peerObj: peer },
          ]);
        });

        // once the signal is accepted calling the signal with signal
        // from other user so that stream can flow between peers
        socketRef.current.on('signal-accepted', (payload) => {
          const item = peersRef.current.find((p) => p.peerId === payload.id);
          item.peer.signal(payload.signal);
        });

        // if some user is disconnected removing his references.
        socketRef.current.on('user-disconnected', (payload) => {
          const item = peersRef.current.find((p) => p.peerId === payload);
          //console.log(item)
          if(item) {
            item.peer.destroy();
          }
          
          const newPeers = peersRef.current.filter(
            (p) => p.peerId !== payload
          );
      //    console.log("old peers ref " + peersRef.current)
          if(peersRef.current) {
          peersRef.current = newPeers
          }
          
    //      console.log("new peers ref " + peersRef.current)
          setPeers(newPeers);
        });
      });
      return () => {
      //  console.log(peersRef.current)
      }
  }, [roomId, userDetails, setStream]);

  function createPeer(userToSignal, callerId, stream) {
    const peer = new Peer({
      initiator: true,
      trickle: false,
      stream,
    });

    peer.on('signal', (signal) => {
      socketRef.current.emit('initiate-signal', {
        userToSignal,
        callerId,
        signal,
      });
    });

    return peer;
  }

  function addPeer(incomingSignal, callerId, stream) {
    const peer = new Peer({
      initiator: false,
      trickle: false,
      stream,
    });

    peer.on('signal', (signal) => {
      socketRef.current.emit('ack-signal', { signal, callerId });
    });

    peer.signal(incomingSignal);

    return peer;
  }

  const endCall = () => {
    stream.getTracks().forEach((track) => {
      setIsConnected(false)
          //console.log(peersRef.current)
      track.stop();
    });  

  }

  if(isLoading) {
    return (
      <div>
        Loading...
      </div>
    )
  }


  return (
    isAuthenticated && (
    <div className="level-item" style={{ display: 'flex', flexWrap: 'wrap' }}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {isConnected && <video muted className="videoSquare" ref={refVideo} autoPlay playsInline />}
        {userDetails.name === user && (
        <>
        <div className="level">
          <div className="level-item">
            <span>Me</span>
          </div>
          <div className="level-item">
            <button className="button is-danger" onClick={endCall}>end call</button>
          </div>
        </div>
        </>
        )}
       
        {userDetails.name !== user && (
        <>
        <div className="level">
        <div className="level-item">
          <span>{userDetails.name}</span>
        </div>
        </div>
        </>
        )}
  
      </div>
      
      {peersRef.current.map((peer, index) => {
      //  console.log(peer)
        return (
          
          <div key={peer.peerId}>
          <Video
            key={peer.peerId}
            peer={peer.peer}
            name={peer.name}
          />
          </div>
        );
      })}
    </div>
    )
  );
};

export default Room;